import React from 'react';
import websocket from '@/lib/websocket';

const useWebsocket = () => {
    return websocket;
};

export default useWebsocket;
